import { render, staticRenderFns } from "./GiveawayStartsIn.vue?vue&type=template&id=9e4ed6f0&lang=pug&"
import script from "./GiveawayStartsIn.vue?vue&type=script&lang=js&"
export * from "./GiveawayStartsIn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports